import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/partner';
const partnerApi = {
	get: (params) => {
		return axiosClient.get(url + '/admin', { params });
	},
	update: (id, body) => {
		return axiosClient.put(url + `/${id}`, body);
	},
	create: (body) => {
		return axiosClient.post(url, body);
	},
	delete: (id) => {
		return axiosClient.delete(url + `/${id}`);
	},
};
export default partnerApi;
